import { CancelWatchModalContentComponentProps } from "./CancelWatchModalContent";

import { airPriceWatchApi } from "@b2bportal/air-price-watch-api";
import { CallState } from "@b2bportal/core-types";
import axios from "axios";
import { useCallback, useMemo, useState } from "react";

export const useCancelWatchModalContent = (
  props: CancelWatchModalContentComponentProps
) => {
  const [callState, setCallState] = useState<CallState>(CallState.NotCalled);

  const onCancelWatch = useCallback(async () => {
    try {
      await airPriceWatchApi(axios).apiV0AlertWatchDeletePost({
        key: props.watch.key,
      });
      setCallState(CallState.Success);
    } catch (e) {
      setCallState(CallState.Failed);
    }
  }, [props.watch.key]);

  const onTryAgain = useCallback(() => {
    setCallState(CallState.NotCalled);
  }, []);

  return useMemo(() => {
    return {
      context: {
        watch: props.watch,
        tripContext: props.tripContext,
        callState,
      },
      handlers: {
        onClose: props.onClose,
        refetch: props.refetch,
        onCancelWatch,
        onTryAgain,
      },
    };
  }, [
    callState,
    onCancelWatch,
    props.onClose,
    props.refetch,
    props.tripContext,
    props.watch,
  ]);
};
